<script>
  export default {

  }
</script>



// WEBPACK FOOTER //
// assets/js/components/blogit/PostList.vue